module.exports = __webpack_public_path__ + "img/bannar3.0a3982a7.png";